import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Settings as SettingsIcon } from "lucide-react";

export default function AdminSettings() {
  const [s, setS] = useState({ max_capacity: 24, default_duration_min: 90 });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/settings", { max_capacity: Number(s.max_capacity), default_duration_min: Number(s.default_duration_min) });
      toast.success("Settings saved");
    } catch { toast.error("Failed to save"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings-page">
      <h1 className="font-serif-display text-4xl text-[#5979A9] mb-2 flex items-center gap-2"><SettingsIcon size={24}/> Capacity & Booking</h1>
      <p className="text-[#4A5568] text-sm mb-7 max-w-2xl">Set the maximum number of guests the restaurant can host at any one time. Reservation slots are released automatically when the duration ends.</p>

      <form onSubmit={save} className="bg-white rounded-2xl border border-[#F0EAE6] p-6 max-w-xl space-y-5">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Maximum Capacity (guests)</label>
          <input type="number" min="1" max="500" value={s.max_capacity}
                 onChange={(e) => setS({...s, max_capacity: e.target.value})}
                 data-testid="settings-max-capacity"
                 className="w-full bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2.5 text-[#2D3748] text-lg font-semibold"/>
          <p className="text-xs text-[#4A5568] mt-2">Total guests the cafe can host at the same time. Default: 24.</p>
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#5979A9]/80 mb-2 font-semibold">Default Reservation Duration (minutes)</label>
          <input type="number" min="30" max="240" step="15" value={s.default_duration_min}
                 onChange={(e) => setS({...s, default_duration_min: e.target.value})}
                 data-testid="settings-default-duration"
                 className="w-full bg-transparent border-b-2 border-[#F0EAE6] focus:border-[#E05947] outline-none py-2.5 text-[#2D3748] text-lg font-semibold"/>
          <p className="text-xs text-[#4A5568] mt-2">After this many minutes, seats are released automatically. Default: 90.</p>
        </div>
        <button type="submit" disabled={saving} data-testid="settings-save-button" className="btn-primary">{saving ? "Saving…" : "Save Settings"}</button>
      </form>
    </div>
  );
}
